import React from "react";
import Booking from "../components/Booking";
import { useParams } from "react-router-dom";
import AccordionList from "../components/Accordion";

const Afspraak = () => {
  const { stepNo } = useParams();

  return (
    <div className="afspraak-container">
      <div className="sidebar-appointment">
        <div className="banner">
          <img
            src="/images/bg-bento-4-queencenter.jpg"
            alt="Hero Background prijslijst"
            className="banner"
          />
        </div>
        <div className="contact">
          <div className="location">
            <img src="/images/icon-location.svg" alt="Icon location" />
            <p>
              Graafseweg 274
              <br />
              6532 ZV Nijmegen
            </p>
          </div>
          <div className="message">
            <img src="/images/icon-contact.svg" alt="Icon contact" />
            <p>
              info@queencenter.nl
              <br />
              <a href="tel:0031615852150">+31 (0) 6 15 85 21 50</a>
            </p>
          </div>
        </div>
        <div className="sticky">
          <div className="sticky-container-1">
            <div className="sticky-content-1">
              <p>Veilig en online betalen!</p>
              <img src="/images/payment.png" alt="" width="100" height="50" />
            </div>
          </div>
          <div className="sticky-container">
            <div className="sticky-content">
              <div className="sticky-title"></div>
              <ul>
                <li>Pijnloze behandeling</li>
                <li>Lichaamseigen stof</li>
                <li>15 jaar ervaring</li>
                <li>Snel en natuurlijk resultaat</li>
              </ul>
              <p>
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <br /> Wij scoren{" "}
                <a
                  href="https://www.google.com/search?q=queen+center&amp;client=firefox-b-d&amp;source=lnms&amp;sa=X&amp;ved=0ahUKEwjKqoz1-dniAhVKzqYKHVo1ALwQ_AUICygA&amp;biw=1440&amp;bih=733&amp;dpr=2#lrd=0x47c709aeeb9ce9e5:0xdc7d04e5f37e8a4a,1,,,"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  9,8 van 10
                </a>
                <br /> berekend uit 43 reviews.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="afspraak-content">
          <h1>Afspraak maken</h1>
          <p>
            Direct een afspraak maken? Dat kan! Maak gemakkelijk online uw
            afspraak door middel van het onderstaande formulier.
          </p>
        </div>
        <div className="afspraak-wrapper">
          <Booking stepNo={stepNo} />
        </div>

        <AccordionList />
      </div>
    </div>
  );
};

export default Afspraak;
